//@flow
/**
 * Utils
 * @module utils
 */

import React from 'react'
import { render } from 'react-dom'
import { ErrorScreen, InvalidInviteScreen } from './screens'

/**
 * checks if in production or dev/testing
 * @memberof utils
 */
export function isProduction(): boolean {
  const { hostname } = window.location
  return (
    process.env.NODE_ENV === 'production' &&
    !(hostname.startsWith('testing.') || hostname === 'localhost')
  )
}

/**
* unmounts main react root and mounts an error screen
* @memberof utils
*/
export function displayErrorScreen(
  msg: string,
  displayRefeshPrompt?: boolean = true,
) {
  render(
    <ErrorScreen text={msg} displayRefeshPrompt={displayRefeshPrompt} />,
    document.getElementById('root'),
  )
}

/**
* unmounts main react root and mounts an invalid learner invite screen
* @memberof utils
*/
export function displayInvalidInviteScreen(proposedInvite: string) {
  render(
    <InvalidInviteScreen proposedInvite={proposedInvite} />,
    document.getElementById('root'),
  )
}

/**
 * Returns a function that resolves after specified milliseconds
 * @memberof utils
 */
export function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

/**
 * Returns the clientId for the provided url.
 * @memberof utils
 */
export function getClientId(): string {
  try {
    const { hostname } = window.location
    return hostname.split('.')[0]
  } catch (err) {
    debugger
    throw err
  }
}



// WEBPACK FOOTER //
// ./src/utils.js